import { render, staticRenderFns } from "./invoice-record.vue?vue&type=template&id=b034a908&scoped=true"
import script from "./invoice-record.vue?vue&type=script&lang=js"
export * from "./invoice-record.vue?vue&type=script&lang=js"
import style0 from "./invoice-record.vue?vue&type=style&index=0&id=b034a908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b034a908",
  null
  
)

export default component.exports